/* recalled-drop-lock v7 — countdown; >1 month → ausverkauft; Vorbestellen unlock */
(() => {
  const root = document.getElementById('DropLock');
  if (!root) return;

  const startsAtMs = Number(root.dataset.startsAtMs) || Date.parse(
    String(root.dataset.startsAt || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2')
  );

  const digitD = root.querySelector('[data-drop-d]');
  const digitH = root.querySelector('[data-drop-h]');
  const digitM = root.querySelector('[data-drop-m]');
  const digitS = root.querySelector('[data-drop-s]');
  const countdownEl = root.querySelector('[data-drop-countdown]');
  const soldoutEl = root.querySelector('[data-drop-soldout]');
  const preorderBtn = root.querySelector('[data-drop-preorder]');
  const preorderBar = document.getElementById('DropPreorderBar');
  const preorderBackBtn = preorderBar?.querySelector('[data-drop-preorder-back]');
  const vorbestellenUrl = root.dataset.vorbestellenUrl || '/collections/vorbestellen';
  const pageAllowsPreorder = root.dataset.preorderAllowed === 'true';

  const adminPreviewMinutes = Number(root.dataset.adminPreviewMinutes || 3);
  const adminPassword = root.dataset.adminPassword || '';

  const previewBtn = document.getElementById('DropPreviewTrigger');
  const previewDialog = document.getElementById('DropPreviewDialog');
  const previewForm = previewDialog?.querySelector('[data-drop-preview-form]');
  const previewInput = previewDialog?.querySelector('[data-drop-preview-input]');
  const previewError = previewDialog?.querySelector('[data-drop-preview-error]');
  const previewCancel = previewDialog?.querySelector('[data-drop-preview-cancel]');

  let timerId = null;

  function showShop() {
    root.hidden = true;
    document.body.classList.remove('drop-lock-active');
  }

  function finishDrop() {
    showShop();
    if (preorderBar) preorderBar.hidden = true;
    document.body.classList.remove('drop-preorder-active');
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  function syncHeaderOffset() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;
    const prevDisplay = headerGroup.style.display;
    headerGroup.style.display = 'block';
    const height = Math.round(headerGroup.getBoundingClientRect().height);
    headerGroup.style.display = prevDisplay;
    if (height > 0) {
      document.body.style.setProperty('--header-group-height', `${height}px`);
      root.style.top = `${height}px`;
      if (preorderBar) {
        preorderBar.style.top = `${height}px`;
      }
    }
  }

  function lockShop() {
    root.hidden = false;
    document.body.classList.add('drop-lock-active');
    document.body.classList.remove('drop-preorder-active');
    if (preorderBar) preorderBar.hidden = true;
    syncHeaderOffset();
  }

  if (!Number.isFinite(startsAtMs) || startsAtMs <= Date.now()) {
    finishDrop();
    root.remove();
    preorderBar?.remove();
    return;
  }

  const adminStorageKey = `recalled.dropAdminPreview:${startsAtMs}`;
  const preorderStorageKey = `recalled.dropPreorderUnlock:${startsAtMs}`;
  const adminPreviewMs = adminPreviewMinutes * 60 * 1000;
  const MONTH_FALLBACK_MS = 30 * 24 * 60 * 60 * 1000;

  /** Same rule as app DropCountdownView.isMoreThanOneMonthAway */
  function isMoreThanOneMonthAway(now = Date.now()) {
    const base = new Date(now);
    const oneMonthLater = new Date(base);
    oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
    if (Number.isNaN(oneMonthLater.getTime())) {
      return startsAtMs - now > MONTH_FALLBACK_MS;
    }
    return startsAtMs > oneMonthLater.getTime();
  }

  function setFarAwayMode(farAway) {
    if (countdownEl) countdownEl.hidden = farAway;
    if (soldoutEl) soldoutEl.hidden = !farAway;
    root.classList.toggle('is-soldout', farAway);
  }

  function readAdminPreview() {
    try {
      const raw = sessionStorage.getItem(adminStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function clearAdminPreview() {
    try {
      sessionStorage.removeItem(adminStorageKey);
    } catch {
      /* ignore */
    }
  }

  function writeAdminPreview() {
    try {
      sessionStorage.setItem(
        adminStorageKey,
        JSON.stringify({ until: Date.now() + adminPreviewMs })
      );
    } catch {
      /* ignore */
    }
  }

  function isAdminPreviewActive(now = Date.now()) {
    const state = readAdminPreview();
    if (!state?.until) return false;
    if (now >= state.until) {
      clearAdminPreview();
      return false;
    }
    return true;
  }

  function writePreorderUnlock() {
    try {
      sessionStorage.setItem(
        preorderStorageKey,
        JSON.stringify({ until: startsAtMs, active: true })
      );
    } catch {
      /* ignore */
    }
  }

  function clearPreorderUnlock() {
    try {
      sessionStorage.removeItem(preorderStorageKey);
    } catch {
      /* ignore */
    }
  }

  function isPreorderUnlockActive(now = Date.now()) {
    try {
      const raw = sessionStorage.getItem(preorderStorageKey);
      if (!raw) return false;
      const state = JSON.parse(raw);
      if (!state?.active) return false;
      const until = Number(state.until) || startsAtMs;
      if (now >= until) {
        clearPreorderUnlock();
        return false;
      }
      return true;
    } catch {
      return false;
    }
  }

  function showPreorderShop() {
    root.hidden = true;
    document.body.classList.remove('drop-lock-active');
    document.body.classList.add('drop-preorder-active');
    if (preorderBar) {
      preorderBar.hidden = false;
      syncHeaderOffset();
    }
  }

  function openVorbestellen() {
    writePreorderUnlock();
    window.location.href = vorbestellenUrl;
  }

  function returnToBanner() {
    clearPreorderUnlock();
    window.location.href = '/';
  }

  function updateDigits(remainingMs) {
    const total = Math.max(0, Math.floor(remainingMs / 1000));
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    if (digitD) digitD.textContent = String(days);
    if (digitH) digitH.textContent = String(hours).padStart(2, '0');
    if (digitM) digitM.textContent = String(minutes).padStart(2, '0');
    if (digitS) digitS.textContent = String(seconds).padStart(2, '0');
  }

  function tick() {
    const now = Date.now();
    const remaining = startsAtMs - now;

    if (remaining <= 0) {
      clearAdminPreview();
      clearPreorderUnlock();
      finishDrop();
      root.remove();
      preorderBar?.remove();
      return;
    }

    if (isAdminPreviewActive(now)) {
      showShop();
      if (preorderBar) preorderBar.hidden = true;
      document.body.classList.remove('drop-preorder-active');
      return;
    }

    if (isPreorderUnlockActive(now) && pageAllowsPreorder) {
      showPreorderShop();
      return;
    }

    // Preorder unlock active but wrong page → keep shop locked
    lockShop();

    const farAway = isMoreThanOneMonthAway(now);
    setFarAwayMode(farAway);
    if (!farAway) updateDigits(remaining);
  }

  preorderBtn?.addEventListener('click', () => openVorbestellen());
  preorderBackBtn?.addEventListener('click', () => returnToBanner());

  previewBtn?.addEventListener('click', () => {
    if (previewError) {
      previewError.hidden = true;
      previewError.textContent = '';
    }
    if (previewInput) previewInput.value = '';
    previewDialog?.showModal();
    window.setTimeout(() => previewInput?.focus(), 0);
  });

  previewCancel?.addEventListener('click', () => previewDialog?.close());

  previewForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const value = (previewInput?.value || '').trim();
    if (adminPassword && value === adminPassword) {
      writeAdminPreview();
      previewDialog?.close();
      if (previewInput) previewInput.value = '';
      if (previewError) previewError.hidden = true;
      showShop();
      return;
    }
    if (previewError) {
      previewError.textContent = 'Falsches Passwort';
      previewError.hidden = false;
    }
    previewInput?.focus();
  });

  tick();
  timerId = window.setInterval(tick, 1000);
  window.addEventListener('resize', () => {
    if (
      document.body.classList.contains('drop-lock-active') ||
      document.body.classList.contains('drop-preorder-active')
    ) {
      syncHeaderOffset();
    }
  });
})();
